module.exports = __webpack_public_path__ + "static/media/iconfinder_linkedin_313117.8658f2df.svg";